module.exports = __webpack_public_path__ + "img/img68.aa5e1910.svg";